import { render } from "./LdapSyncConnection.vue?vue&type=template&id=96867eca&scoped=true"
import script from "./LdapSyncConnection.vue?vue&type=script&lang=js"
export * from "./LdapSyncConnection.vue?vue&type=script&lang=js"

import "./ldap-sync-connection.scss?vue&type=style&index=0&id=96867eca&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96867eca"]])

export default __exports__